import { MenuItem, Text } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';
import { useGlobalUI } from '@/components/GlobalUIProvider';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import { DeviceAsset } from '@/types/assets';
import RecoveryKeyModal from '../DeviceSecurityPanel/RecoveryKeyModal';

type RecoveryKeyMenuItemProps = {
  deviceAsset: DeviceAsset;
  isLoading: boolean;
};

const RecoveryKeyMenuItem = ({
  deviceAsset,
  isLoading,
}: RecoveryKeyMenuItemProps) => {
  const { t } = useTranslation('assets');
  const { openModal, closeModal } = useGlobalUI();
  const organizationId = useGetOrganizationId();

  const handleRevealRecoveryKey = async () => {
    if (!organizationId || !deviceAsset.device?.id || !deviceAsset.serialNumber)
      return;
    openModal(
      <RecoveryKeyModal deviceAsset={deviceAsset} visible hide={closeModal} />
    );
  };

  return (
    <MenuItem
      id="reveal-recovery-key-menu-item"
      onClick={handleRevealRecoveryKey}
      disabled={isLoading}>
      <Text>{t('assetDetailsButtonMenu.revealRecoveryKey')}</Text>
    </MenuItem>
  );
};

export default RecoveryKeyMenuItem;
